import { gql } from "@apollo/client";

const UPLOAD_MESSENGER_CALL_RECORDING = gql`
  mutation uploadMessengerCallRecording($callId: String!, $file: Upload!) {
    uploadMessengerCallRecording(callId: $callId, file: $file) {
      id
      callId
      recordingUrl
    }
  }
`;

export default UPLOAD_MESSENGER_CALL_RECORDING;
